export const ICC_INCOTERMS_2020_URL =
  'https://iccwbo.org/resources-for-business/incoterms-rules/';

export const INCOTERMS_GOLDEN_FOB = 'FOB';
export const INCOTERMS_2020_COUNT = 11;
